import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit} from '@angular/core';

import { OrderService } from '../../services/order.service';
import { InventoryService } from '../../services/inventory.service';

@Component({
  selector: 'app-position-detail',
  providers: [OrderService, InventoryService],
  templateUrl: './position-detail.component.html',
  styleUrls: ['./position-detail.component.css']
})
export class PositionDetailComponent implements OnInit, AfterViewInit {

  @Input("position") position: any;
  @Input("scanItems") scanItems: number = 0;
  @Input("ovp") ovp: boolean;
  @Input("iscomplete") iscomplete: boolean;
  @Output("onResetScan") resetScan = new EventEmitter<any>();
  @Output("onOvpScan") ovpScan = new EventEmitter<any>();
  @Output("onManualScan") manualScan = new EventEmitter<any>();
  
  article: any;
  selectedStock: string = null;
  query: any;
  selectedArticle: string = null;
  selectedCount: number = 0;
  ovpItems: number;

  constructor(private inventoryService: InventoryService) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    
  }

  ngOnChanges(changes: any) {
    if (this.position!=null) {
      this.getArticle(this.position.articleRef);
    }
  }

  doOVPScan() {
    this.ovp=!this.ovp;
    // the article will be added or removed from the list of articleOVP
    this.ovpScan.emit(this.article.articleRef);
  }

  doScanManual() {
    this.manualScan.emit(this.position);
  }

  doScanReset() {
    this.resetScan.emit(this.position.articleRef);
  }

  getArticle(articleRef: string) {
    this.inventoryService.getArticle(articleRef)
      .subscribe(
      data => {
        this.article = data;
      },
      error => {
        // do nothing, just dont show any article info
      });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/position-detail/position-detail.component.ts